import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AlphaHttpClient } from './alpha-http-client';

@Injectable({ providedIn: 'root' })
export class CaseDefinitionService {
    private httpClient = inject(AlphaHttpClient);

    private domainUrl = {
        type: 'environment',
        value: {
            __alpha_env__: 'ALPHA_UI_CONFIG_SERVICE_URL',
        },
    };

    saveCaseDefinition(caseDefinitionSaveObject: {
        projectId: string;
        caseSchema: { [key: string]: any };
        version: string;
        configType: string;
    }) {
        return this.httpClient.post(this.domainUrl, '/case-definition/save', caseDefinitionSaveObject);
    }

    fetchCaseDefinitions(projectId: string, generateType: boolean = false): Observable<CaseDefinitionResponse> {
        return this.httpClient.post<CaseDefinitionResponse>(this.domainUrl, '/case-definition/fetch', {
            projectId,
            generateType,
        });
    }
    fetchCaseDefinitionsType(projectId: string): Observable<CaseDefinitionTypeResponse> {
        return this.httpClient.post<CaseDefinitionTypeResponse>(this.domainUrl, '/case-definition/schema-type', {
            projectId,
        });
    }
}

export interface CaseDefinitionResponse {
    cdid: number;
    version: string;
    caseSchema: {
        $schema: string;
        title: string;
        type: string;
        properties: Record<string, any>;
    };
    caseType: string;
    active: boolean;
    createdAt: string;
    updatedAt: string;
    enquiry: boolean;
    project: {
        id: number;
        projectId: string;
        name: string;
        caseType: string;
        icon: string | null;
        version: string;
        createdAt: string;
        updatedAt: string;
        status: string;
        disable: boolean;
        description: string;
        active: boolean;
        appConfig: Record<string, any>;
        enquiry: boolean;
    };
    schemaType?: string;
}

export interface CaseDefinitionTypeResponse {
    schemaType: string;
    caseSchema: {
        $schema: string;
        title: string;
        type: string;
        properties: Record<string, any>;
    };
}
